import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FileDown } from 'lucide-react';
import { API } from '@/App';
import { WorksheetFill } from './WorksheetFill';
import { WorksheetSharedFeed } from './WorksheetSharedFeed';

/**
 * Decides what a member sees on an exercise or supplement.
 *
 * Where a worksheet is published, the interactive one replaces the embedded PDF viewer and the
 * original stays as a quiet download at the bottom. Where there is no worksheet, the PDF viewer
 * renders exactly as it always did.
 */
export function WorksheetSlot({ contentId, originalUrl, children }) {
  const [state, setState] = useState({ loading: true, data: null });

  useEffect(() => {
    let live = true;
    axios.get(`${API}/worksheets/by-content/${contentId}`)
      .then((res) => { if (live) setState({ loading: false, data: res.data }); })
      .catch(() => { if (live) setState({ loading: false, data: null }); });
    return () => { live = false; };
  }, [contentId]);

  if (state.loading) return null;

  const worksheet = state.data?.worksheet;
  if (!worksheet) return children;

  return (
    <>
      <WorksheetFill
        worksheet={worksheet}
        initialResponse={state.data.response}
      />
      <WorksheetSharedFeed worksheetId={worksheet.id} />
      {originalUrl && (
        <a
          href={originalUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-700 underline"
          data-testid="worksheet-original-pdf"
        >
          <FileDown className="w-3.5 h-3.5" /> Download the original PDF
        </a>
      )}
    </>
  );
}

export default WorksheetSlot;
